export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'FRIENDS_LOCATION_MAP_OBJ':
      return payload
    case 'REMOVE_FRIENDS_LOCATION_MAP_OBJ':
      return []
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
